<!--- End Global-loader-->
<router-outlet></router-outlet>